namespace SP {

    export interface purchaeOrderLocationInfo {
        location: string;
        totalQty: number;
        deliveredQty: number;
    }
    export interface purchaseOrderInfo {
        id: number;
        state: PurchaseOrderState;
        purchaseOrderType: PurchaseOrderType;
        supplier: supplierInfo;
        expectedDeliveryDate: string,
        orderDate: string,
        externalId: string,
        referenceNo: string,
        trackingNumbers: string,
        customerId: string,
        items: PurchaseOrderLineInfo[];
        lineCount: number;
        itemsTotal: number;
        deliveredItems: number;
        locationInfos: purchaeOrderLocationInfo[];
    
    }
}